module.exports = __webpack_public_path__ + "static/aboutus-2-min-e539fc974075183cb07da355843107a2.png";